import Vue from 'vue'
import Router from 'vue-router'

import index from '@/page/index.vue'
import solution from '@/page/solution.vue'
import solution2 from '@/page/solution-2.vue'
import solution3 from '@/page/solution-3.vue'
import solution4 from '@/page/solution-4.vue'
import paas from '@/page/paas.vue'
import shop from '@/page/shop.vue'
import paas2 from '@/page/paas-2.vue'
import activity from '@/page/activity.vue'
import cooperation from '@/page/cooperation.vue'
import news from '@/page/news.vue'
import newsDetail from '@/page/news-detail.vue'
import about from '@/page/about.vue'
import file from '@/page/file.vue'


Vue.use(Router)

let service = new Router({
  mode: 'history',
  // base:'./static/',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '',
      redirect:'/index'
    },
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/solution',
      name: 'solution',
      component: solution
    },
    {
      path: '/solution2',
      name: 'solution2',
      component: solution2
    },
    {
      path: '/solution3',
      name: 'solution3',
      component: solution3
    },
    {
      path: '/solution4',
      name: 'solution4',
      component: solution4
    },
    {
      path: '/paas',
      name: 'paas',
      component: paas
    },
    {
      path: '/shop',
      name: 'shop',
      component: shop
    },
    {
      path: '/paas2',
      name: 'paas2',
      component: paas2
    },
    {
      path: '/activity',
      name: 'activity',
      component: activity
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/file',
      name: 'file',
      component: file
    },
  ],
})
export default service;



// WEBPACK FOOTER //
// ./src/router/index.js